export const MARKETING_THEME = "theme-friendly";
